export default __webpack_public_path__ + "static/media/falcon-bb.550bc4fc.svg";